/* eslint-disable no-console,no-undef, camelcase */
/* eslint-disable react/no-unknown-property */
import React, { Component, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import _, { isNull, isUndefined } from 'lodash';
import { FieldContainer } from '../EventDetails/styles';
import { LayoutNew, CommentContentContainer, CommentInnerContainer, ChallengeGrid, ChallengeInfoGridNew, CommentGridNew, ChatGroup, ChatUsers, ChatTextArea, ChatCommentContent, IconContainer, InputImage, StyledTabsNew, Main, EventsButton, ButtonContainer, IconContainerNew, InputImageNew, /*CompletedChallengeCard,*/ FormContainer, TopContainer, TabContainer, IconWrapper, HoverIconWrapper, NewTabView } from './styles';
import { NoComments } from '../SocialFeeds/styles';
import CommentsV2 from '../CommentsV2';
import BehaviorChallengeComments from '../CommentsV2/behaviorChallengeComments'
import Waiting from '../Waiting';
import DetailedChallengeV2 from './DetailedChallengeV2'
// import GroupChallengeLeaderboardV2 from './GroupTeamGoal/newGroupChallenge';
import Loading from '../Loading';
import GroupOverViewScreen from './OverViewScreen/groupOverview'
import MyTaskTabV2 from "./MyTaskTab/myTaskTab";
// const StartChallengePopUp = React.lazy(() => import("./StartChallengePopUp"));
import {
  getChallengeDetails, addCommentOnChallenge, getCommentsOnChallenge, getChallengeCompetitors,
  addCommentReplyOnChallenge, getUserProfileImage, getUserId, getTeamChallenge, updateDailyTask, changeWeekDashboard, getUserListOfChallenges, getUserLastSync, getUserOverviewDetails, getChallengeCsvData, emptyChallengeDetails, toggleDummyChallenges, setChallengeInviteStatus,
  joinOrLeaveChallenge, deleteChallengeById, getInviteAmigosList, UpdateUserLiveChallengeStatus
} from '../../redux/actions';
import Image from '../Image';
import { OverlayTrigger, Popover, Tab } from "react-bootstrap";
import MyProgressTab from "./MyProgressTab/myProgressTabV2";
import { ProfileImage } from './OverViewScreen/styles';
import { withRouter } from "react-router-dom";
import moment from "moment";
import { resetOrientation, getOrientation, checkImage, getPermissionStatus, convertDateInTimezone, getUnit, commaSeperator, fetchApi } from '../../utils/methods';
import { imageErrorMessage, ImageUrl } from '../../utils/constants';
import BehaviorChallengeDetail from "./BehaviorChallengeNew";
const DemoPopup = React.lazy(() => import('../WhyAmigoCommon/ChallengePopup'));
import RightSideSection from '../ChallengeDetailsV2/MyTaskTab/behaviorChallengeRightSide'
import { AboutContainer, CommentContent, PostButton } from '../EventDetails/styles';
import { ImageWrapper } from '../SocialFeeds/styles';
import { RightContainer } from './MyTaskTab/styles';
// import GroupRightSection from './GroupTeamGoal/groupRightSection';
// import ClassicRightSection from './GroupTeamGoal/classicChallengeRight';
// import ClassicChallengeLeaderboard from './GroupTeamGoal/classicLeaderboard';
// import SurvivorRightSection from './survivorChallengeRight';
import SurvivorOverViewScreen from './OverViewScreen/survivorOverview';
// import SurvivorLeaderboard from './ChallengeLeaderboardV2/survivorLeaderboard';
import { withTranslation } from 'react-i18next';
import SocialFeedsEmojiPicker from '../SocialFeedsEmojiPicker';
// import TeamChallengeRight from './TeamChallenge/teamChallengeRight';
import TeamOverview from './OverViewScreen/teamOverview';
// import TeamLeaderboard from './TeamChallenge/teamLeaderboard';
import CommonTextArea from '../common/CommonTextArea/CommonTextArea';
import ChallengeDetailTop from './challengeTopViewCommon';
import {  /*LeaveChallengeIcon, InviteBuddyIcon,*/  DownloadIconNew, ExitChallenge, RecognitionWarningIcon, AdminLeftArrowIcon, NotificationIcon, EditIconBranding, DeleteChallengeIcon } from '../../utils/icons';
import HoverButton from '../common/HoverButtonV2';
import DeleteAndLeavePopup from './challengeLeavePopup';
const InviteAmigoPopUp = lazy(() => import("./InviteAmigoPopUp/inviteChallengePopup"));
import CSVList from "../AttendeesModal/CSVList";
import parse from 'react-html-parser';
import ClassicRightScreen from './ClassicRightScreen';
import ChallengeLeaderBoard from './ChallengeLeaderboardV2/challengeLeaderboard';
import SurvivorRightScreen from './SurvivorRightScreen';
import CommonModal from '../common/CommonModal/CommonModal';
import CharityChallengeRightScreen from './CharityChallengeRightScreen';
import DeletePopup from '../DeletePostPopup/deletePopupBranding'
import ClassicTeamRightScreen from './TeamChallenge/ClassicTeamRightScreen';
import CustomNotification from './customNotification'
import AddUserPopup from './addUser'
import { GetACMEChallengeCompetitors, GetChallengeCompetitors, GetGroupChallengeCompetitors } from '../../redux/constants/apiConstants';

let csvHeaders = [];
class ChallengeDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: '',
      isUpdatedImage: false,
      selectedTab: 1,
      objIndex: 0,
      taskUpdated: 0,
      selectedDate: moment(moment()._d, 'MM DD YYYY').format('MM-DD-YYYY'),
      refreshFileReader: false,
      imgSrc: [],
      showVideo: false,
      joinOrLeave: 1,
      exitChallenge:0,
      displayEmoji: false,
      description: '',
      position: {start:0, end:0},
      isButtonDisabled: false,
      tabValue:1,
      deleteChallengeId:null,
      showDeletePopup: false,
      showLeavePopup: false,
      showExitPopup: false,
      leaveChallengeId: null,
      showInviteAmigoPopup: false,
      printChallengeCSV: false,
      updatedChallengeCSV: {},
      path: this.props.history.location.pathname,
      showCustomModel: null,
      showAddUserPopup: false,
      popupType:"",
      challengeType: "",
      hasCompanyInRoute: this.props.history.location.pathname.includes("/company/")
    }
    this.emojiref = React.createRef();
  }
  
    
  
  componentDidMount() {
    document.addEventListener("mousedown", this.handleEmojiClick);
    const { location: { pathname, search }, getChallengeDetails, getCommentsOnChallenge, fetchUserProfileImage, fetchUserId, match, getUserListOfChallenges,role,companyInfo,user } = this.props;
    const isAdminPage = pathname?.includes('company');
    const isSuperAdmin = role === "ADMIN";
    const companyId = isAdminPage || isSuperAdmin ? companyInfo?.id : user?.company_id;
    window.console.log("companyInfo",companyInfo);
    window.console.log("user",user)
    const StringArray = pathname.split('/');
    if (StringArray[(StringArray.length - 1)] != '') {
      this.props.toggleDummyChallenges(search.includes('ACME=true'));
      getChallengeDetails(parseInt(match.params.id,10),companyId);
      getCommentsOnChallenge(parseInt(match.params.id,10));
      getUserListOfChallenges(parseInt(match.params.id,10));

    } else {
      getChallengeDetails(StringArray[(StringArray.length - 2)],companyId);
      getCommentsOnChallenge(StringArray[(StringArray.length - 2)]);
      
    }
    if (!this.props.syncTime) {
      this.props.getUserLastSync();
    }
    fetchUserId();
    if (!this.props.profileImage) fetchUserProfileImage();
    this.checkBase64(this.props.profileImage);
    this.setState({
      hasCompanyInRoute: this.props.history.location.pathname.includes("/company/")
    })
  }


  componentDidUpdate(prevProps) {
    const { location: { pathname, search }, getChallengeDetails, getCommentsOnChallenge, match, getUserListOfChallenges, role , companyInfo,user} = this.props;
    const StringArray = pathname.split('/');
    const lastSegment = StringArray[StringArray.length - 1];
    const challengeId = parseInt(lastSegment, 10);
    if(isNaN(challengeId)){
      this.updateLiveStatus()

    }

    const isAdminPage = pathname?.includes('company');
    const isSuperAdmin = role === "ADMIN";
    const companyId = isAdminPage || isSuperAdmin ? companyInfo?.id : user?.company_id;

    if (pathname !== prevProps.location.pathname) {
      if (StringArray[(StringArray.length - 1)] != '') {
        if(!Number.isNaN(challengeId)){
          this.props.toggleDummyChallenges(search.includes('ACME=true'));
          getChallengeDetails(parseInt(match.params.id,10),companyId);
          getCommentsOnChallenge(parseInt(match.params.id,10));
          // prevProps.challengeAttendees != this.props.challengeAttendees && getUserListOfChallenges(parseInt(match.params.id,10));
          getUserListOfChallenges(parseInt(match.params.id,10));

        }
      } else {
        getChallengeDetails(StringArray[(StringArray.length - 2)],companyId);
        getCommentsOnChallenge(StringArray[(StringArray.length - 2)]);
      }
    }
  }

  updateDownloadCSV = (bool) =>{
    this.setState({ printChallengeCSV: bool })
  };

   

  navigateEdit = () => {
    const { location: { pathname }, history } = this.props;
    const StringArray = pathname.split('/');
    if (StringArray[StringArray.length - 1] != '') {
      history.push(`/challenges/${StringArray[StringArray.length - 1]}/edit`);
    } else {
      history.push(`/challenges/${StringArray[StringArray.length - 2]}/edit`);
    }
  }

  showEmojiPicker = () => {
    this.setState((prev) => ({
      displayEmoji: !prev.displayEmoji
    }))
  }

  hideEmojiPicker = () => {
    this.setState({
      displayEmoji: false
    })
  }

  handleEmojiClick = (event) => {
    if (!isNull(this.emojiref) && !isUndefined(this.emojiref) && !(this.emojiref && this.emojiref.current && this.emojiref.current.contains(event.target))) {
      // this.setState({displayEmoji: false});
    }
  };

  toCodePoints = function (string) {
    let chars = "";
    for (let i = 0; i < string.length; i++) {
      let c1 = string.charCodeAt(i);
      let b1 = string.charAt(i);
      if (c1 >= 0xD800 && c1 < 0xDC00 && i + 1 < string.length) {
        let c2 = string.charCodeAt(i + 1);
        if (c2 >= 0xDC00 && c2 < 0xE000) {
          chars = chars + ("&#" + ((+0x10000 + ((c1 - 0xD800) << 10) + (c2 - 0xDC00))) + ";");
          i++;
          continue;
        }
      }
      else {
        chars = chars + b1;
      }
    }
    return chars;
  }

  checkBase64(profileImage) {
    if (profileImage) {
      let arr = profileImage.split('/');
      if (arr[0] !== 'profile-Image') {
        this.setState({
          isUpdatedImage: true
        })
      }
      else {
        this.setState({
          isUpdatedImage: false
        })
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.profileImage != nextProps.profileImage) {
      this.checkBase64(nextProps.profileImage)
    }
  }
  componentWillUnmount() {
    document.addEventListener("mousedown", this.handleEmojiClick);
    this.props.emptyChallengeDetails();
    this.props.toggleDummyChallenges(false);
  }

  showProfileImage = () => {
    const { profileImage } = this.props;
    const { isUpdatedImage } = this.state;
    if (isUpdatedImage) {
      return (<img src={profileImage} alt="avatar" style={{borderRadius:'50%'}}/>)
    }
    else {
      return (<Image image={profileImage} alt="avatar" style={{borderRadius:'50%'}}/>)
    }
  };

  onChange = (e) => {
    let position = this.getPosition(e.target);
    e.target.value !== ' ' ?
      this.setState({
        comment: e.target.value,
        position: position
      }) : null;
  };

  onChangeImage = (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            imgSrc: [reader.result],
            refreshFileReader: true
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: [baseImage],
                refreshFileReader: false
              });
            });
          });
        };

        document.getElementById('uploadPhoto').value = '';
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById('uploadPhoto').value = '';
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById('uploadPhoto').value = '';
    }
  };

  removeImage = () => {
    this.setState({
      imgSrc: []
    });
  };

  postComment = (id) => {
    const { addCommentOnChallenge } = this.props;
    const { comment, imgSrc } = this.state;
    let html = this.toCodePoints(comment)
    addCommentOnChallenge({ challenge_id: id, comment: html, image: imgSrc.length >= 1 ? imgSrc[0] : '' });
    this.setState({
      comment: '',
      imgSrc: []
    })
  };

  setActiveTab = (active) => {
    this.setState({ selectedTab: active })
  }
  getListOfUser = () => {
    const { challengeAttendees } = this.props;
    return <div>
      {
        challengeAttendees && challengeAttendees.length ? challengeAttendees.map((user, index) => (
          (index < 3) ? <ProfileImage chatHeader={1} key={index}>
            <Image image={user.profile_image} alt="avatar" />
          </ProfileImage> : null
        )
        ) : null
      }
      {
        challengeAttendees && challengeAttendees.length > 3 ?
          <ProfileImage chatHeader={1}>
            +{challengeAttendees && challengeAttendees.length - 3}
          </ProfileImage> : null
      }
    </div>
  };
  setObjIndex = (index, taskUpdated = 0, selectedDate = '') => {
    this.setState({ objIndex: index, taskUpdated: taskUpdated, selectedDate: selectedDate })
  }

  changeModal = () => {
    this.setState((prevState) => ({
      showVideo: !prevState.showVideo
    }));
  }

  onEmojiSelect = (emoji, id, native, skin) => {
    this.setState({
      emojiData: emoji,
      emojiId: id,
      emojiNative: native,
      emojiSkin: skin
    })
    this.addInspirationV2(native);
  }

  popover = (value) => (
    <Popover
      id="popover-basic"
      style={{
        width: "auto",
        padding: "9px 14px",
        background: "#FFFFFF",
        border: "1px solid #005c87",
        boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
        borderRadius: "6px",
      }}
    > 
      <div
        style={{
          fontFamily: "Rubik",
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "20px",
          color: "#005c87",
          textAlign: "center",
        }}
      >
        {value}
      </div>
    </Popover>)

  getPosition(el) {
    let start = 0, end = 0, normalizedValue, range,
      textInputRange, len, endRange;

    if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end
    };
  }

  addInspirationV2 = (e) => {
    let newText = this.state.comment.slice(0, this.state.position.start) + e + this.state.comment.slice(this.state.position.end);
    this.setState({
      position: { start: this.state.position.start + e.length, end: this.state.position.end + e.length },
      comment: newText,
    });
  };

  joinChallenge = (challengeId, isJoined) => {

    const { joinOrLeaveChallenge } = this.props;
    
    // if (challenge.is_user_challenge === 1) {
    //   const data = {
    //     challenge_id: challengeId,
    //     is_joined: 2
    //   };
    //   joinOrLeaveChallenge(data);
    // }else{
    //   const data = {
    //     challenge_id: challengeId,
    //     is_joined: isJoined
    //   };
    //   joinOrLeaveChallenge(data);
    // }
    const data = {
      challenge_id: challengeId,
      is_joined: isJoined
    };
    joinOrLeaveChallenge(data);

    this.setState({ isButtonDisabled: true });
    window.setTimeout(() => {
      this.setState({ isButtonDisabled: false });
    }, 2000);
    this.setState({ showExitPopup: false });
  };

  updateTabValue = (value) => {
    this.setState({ tabValue: value });
  }

  schedule = () =>(
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
      <path d="M7.11474 16C7.20246 16.0005 7.28942 15.9837 7.37063 15.9505C7.45184 15.9173 7.52571 15.8685 7.58799 15.8067C7.65047 15.7447 7.70005 15.671 7.73389 15.5898C7.76773 15.5086 7.78516 15.4214 7.78516 15.3334C7.78516 15.2454 7.76773 15.1583 7.73389 15.0771C7.70005 14.9959 7.65047 14.9221 7.58799 14.8602L2.14226 9.41445C1.76779 9.03951 1.55745 8.53127 1.55745 8.00136C1.55745 7.47145 1.76779 6.9632 2.14226 6.58827L7.58799 1.14253C7.71351 1.01702 7.78402 0.846784 7.78402 0.66928C7.78402 0.491776 7.71351 0.321542 7.58799 0.196028C7.46248 0.0705132 7.29224 0 7.11474 0C6.93723 0 6.767 0.0705132 6.64149 0.196028L1.19575 5.64176C0.885384 5.95135 0.639141 6.31912 0.471127 6.72402C0.303112 7.12892 0.216628 7.56298 0.216628 8.00136C0.216628 8.43973 0.303112 8.8738 0.471127 9.2787C0.639141 9.68359 0.885384 10.0514 1.19575 10.361L6.64149 15.8067C6.70377 15.8685 6.77763 15.9173 6.85885 15.9505C6.94006 15.9837 7.02702 16.0005 7.11474 16Z" fill="#F37A65"/>
    </svg>
  ) 

  showHideInviteAmigoPopup = () => {
    this.setState((prevState) => ({
      showInviteAmigoPopup: !prevState.showInviteAmigoPopup
    }), () => this.props.getInviteAmigosList(this.props.userId, this.props.challenge.id))
  };

  updateLiveStatus = () => {
    const { UpdateUserLiveChallengeStatus,history, challenge, isAdminChallenge } = this.props;

    const fromDashboard= this.props.history.location.state?.fromDashboard;
    UpdateUserLiveChallengeStatus();
    if(challenge?.is_completed){
      // history.goBack()
      if(history.location.pathname.includes("/company")){
        history.push("/company/challenges/completed")
      }else{
        history.push("/challenges/completed")
      }
    }
    else if(isAdminChallenge){
      history.push("/company/challenges")
    }else if (fromDashboard) {  
      history.push("/portal")
    }
    else{
      history.push("/challenges")
    }
    
  };
  
  editChallengeRedirection = (challengeId) => {
    const { history } = this.props;
    if(history.location.pathname.includes("/company")){
      history.push(`/company/challenges/edit/${challengeId}`)
    }
    else{
      history.push(`/challenges/edit/${challengeId}`)
    }
  }

  headerView = () =>{
    const { tabValue, isButtonDisabled, hasCompanyInRoute } = this.state;
    const { challenge, role, userId, /*challengeCSVStatus,*/ userPermissions, /*challengeCsvData ,*/ brandingColor,allRoles,location, companyInfo, user} = this.props;
    const challengeId = challenge && challenge.id;
    // const valid = convertDateInTimezone(challenge.end_date)._d >= moment()._d;
    let currentDate = moment();
    // const valid = moment(convertDateInTimezone(challenge.start_date)._d).format('MM-DD-YYYY')<=moment(currentDate).format('MM-DD-YYYY');
    const valid = moment().isSameOrAfter(moment(convertDateInTimezone(challenge.start_date)),'day');

    // const hasCompanyInRoute = path.includes("/company/");

    const showEditButton= ((role ==="ADMIN")|| (((role==="WELLNESS_ADMIN" )||role==="CONTENT_CREATOR")&&challenge.is_global_challenge!==1))&& moment(convertDateInTimezone(challenge.start_date)._d).format('MM-DD-YYYY')>=moment(currentDate).format('MM-DD-YYYY')&&challenge.is_user_challenge!==1?true:false;
    const startChallengeEditButton=((role==="ADMIN") || (((role==="WELLNESS_ADMIN")||role==="CONTENT_CREATOR")&&challenge.is_global_challenge!==1))&& moment(convertDateInTimezone(challenge.start_date)._d).format('MM-DD-YYYY')<=moment(currentDate).format('MM-DD-YYYY')&&challenge.is_user_challenge!==1&&challenge.challenge_status!="over"&&!challenge.is_global_challenge?true:false;
    const hasAnyRole = allRoles?.some((data) => [3, 15, 12].includes(data?.rid));

    const isAdminPage = location?.pathname?.includes('company');
    const isSuperAdmin = role === "ADMIN";
    const companyId = isAdminPage || isSuperAdmin ? companyInfo?.id : user?.company_id;

    return(
      <TabContainer marginBottom="25px" paddingRight="8px" >
        <IconWrapper margin="auto 0px auto 0">
          <HoverButton
            title={this.props.t("Back")}
            width="9px"
            height="16px"
            svgPath={<AdminLeftArrowIcon/>}
            // svgPath={this.schedule()} 
            onClick={() => this.updateLiveStatus() }
            backgroundColor={"white"}
            backgroundColorActive={brandingColor}
          />
        </IconWrapper>
        <NewTabView 
          backgroundColor={brandingColor}
          width
          padding
          active={tabValue===1}
          onClick={() => this.updateTabValue(1)}
        >
          {this.props.t("Challenge")}
        </NewTabView>
        <NewTabView
          backgroundColor={brandingColor}
          width
          padding
          active={tabValue===2}
          onClick={() => this.updateTabValue(2)}
        >
          {this.props.t("Leaderboard")}
        </NewTabView>
        <NewTabView
          backgroundColor={brandingColor}
          width
          padding
          active={tabValue===3}
          onClick={() => this.updateTabValue(3)}
        >
          {this.props.t("Chat")}
        </NewTabView>
        <HoverIconWrapper>
          {(showEditButton ||startChallengeEditButton) && challenge.challenge_status!="over"&&hasCompanyInRoute&&<IconWrapper margin={"auto 0 auto 0"}>
            <HoverButton
              title={this.props.t("Edit Challenge")}
              width="18px"
              height="18px"
              svgPath={<EditIconBranding/>} 
              onClick={() => this.editChallengeRedirection(challengeId)}
              backgroundColor={"white"}
              backgroundColorActive={"#DA6C74"}
            />
          </IconWrapper>}
          {((challenge.is_global_challenge && role === "ADMIN" || getPermissionStatus("Download challenge CSV", userPermissions)) || hasAnyRole ) && valid && <IconWrapper margin={"auto 0 auto 0"}>
            <HoverButton
              title={this.props.t("Download CSV")}
              width="40px"
              height="40px"
              svgPath={<DownloadIconNew/>} 
              onClick={() => {
                if(challenge.challenge_type === 'group'){
                  this.fetchGroupChallengeCsvData(challenge?.id, challenge?.event_type);
                }else{
                  this.fetchChallengeCsvData(challenge?.id, challenge?.event_type, 'all',companyId);
                }
              }}
              backgroundColor={"white"}
              backgroundColorActive={"#DA6C74"}
            />
          </IconWrapper>}

          {((role==="ADMIN" ) || (role==="WELLNESS_ADMIN" && hasCompanyInRoute ) || (challenge.created_by === userId && hasCompanyInRoute  )) && challenge.challenge_status!="over" &&<IconWrapper 
            margin={"auto 0 auto 0"}
          >
            <HoverButton
              title={this.props.t("Notification")}
              width="18px"
              height="20px"
              svgPath={<NotificationIcon/>} 
              onClick={() => this.setState({showCustomModel: true})}
              backgroundColor={"white"}
              backgroundColorActive={"#DA6C74"}
            />
          </IconWrapper>}
          {/* (role==="WELLNESS_ADMIN" && hasCompanyInRoute ) || */}

          {((role==="ADMIN" ) || (role==="WELLNESS_ADMIN" && hasCompanyInRoute ) ||  (challenge.created_by === userId && hasCompanyInRoute )) && challenge.challenge_status!="over" &&<IconWrapper 
            margin={"auto 0 auto 0"}
          >
            <HoverButton
              title={this.props.t("Delete Challenge")}
              width="18px"
              height="20px"
              svgPath={<DeleteChallengeIcon/>} 
              onClick={() => this.showDeletePopup(challengeId)}
              backgroundColor={"white"}
              backgroundColorActive={"#DA6C74"} 
              activeSvgPath={<DeleteChallengeIcon color={"white"}/>}
            />
          </IconWrapper>}
          {/* {((role==="ADMIN" || role==="WELLNESS_ADMIN"|| challenge.created_by === userId) && challenge.is_user_challenge===1) && challenge.challenge_status !== 'over'&& challenge.challenge_status === 'joined' &&<IconWrapper margin={"auto 0 auto 0"}>
            <HoverButton
              title={this.props.t("Invite Buddies")}
              width="20px"
              height="20px"
              svgPath={<InviteBuddyIcon/>} 
              onClick={() => this.showHideInviteAmigoPopup()}
              backgroundColor={"#005C870D"}
              backgroundColorActive={"#005C87"}
            />
          </IconWrapper>} */}
        </HoverIconWrapper>
        {tabValue !== 2 && tabValue !== 3 && challenge.challenge_status === 'joined' && (role !== "ADMIN"  || role !== "WELLNESS_ADMIN") && !hasCompanyInRoute && (
          <IconWrapper margin={(role === "ADMIN" || role === "WELLNESS_ADMIN" || challenge.created_by === userId) ? "auto 0px auto 0" : "auto 0px auto auto"}>
            <HoverButton
              title="Exit Challenge"
              width="20px"
              height="20px"
              svgPath={<ExitChallenge />} 
              onClick={isButtonDisabled ? null : () => this.exitChallenge(challengeId)}
              backgroundColor="white"
              backgroundColorActive="#DA6C74"
            />
          </IconWrapper>
        )}
      </TabContainer>
    )
  }




  showDeletePopup = (id) => {
    this.setState({ showDeletePopup: true, deleteChallengeId:id });
  };

  showLeavePopup = (id) => {
    this.setState({ showLeavePopup: true, leaveChallengeId:id });
  };


  exitChallenge = (id) => {
    this.setState({ showExitPopup: true, leaveChallengeId:id });
  };

  hideDeletePopup = () => {
    this.setState({ showDeletePopup: false });
  };

  hideLeavePopup = () => {
    this.setState({ showLeavePopup: false });
  };

  hideExitChallenge = () => {
    this.setState({ showExitPopup: false });
  };

  
 
  deleteTeam = () => {
    const { deleteChallengeById, challenge } = this.props;
    this.setState(
      {
        deleteChallengeId:null, showDeletePopup: false
      },
      () => {
        deleteChallengeById(challenge?.id);
      }
    );
  };

  leaveTeam = (id) => {
    this.setState(
      {
        leaveChallengeId:null, showLeavePopup: false
      },
      () => {
        this.joinChallenge(id, 0)
      }
    );
  };



  fetchGroupChallengeCsvData = async (challengeId, challengeType, companyId) => {

    const endPoint = GetGroupChallengeCompetitors;
    try {
      const res = await fetchApi(`${endPoint}/${challengeId}/${challengeType}${companyId ? `?company_id=${companyId}`: ''}`);
      if(res.message) {
        toast.error(res.message);
      } else {
        this.printAction(true,res?.data?.[0])
      }
    } catch(error) {
      toast.error(error.message);
      // dispatch(networkError(error.message));
    }

  }

  fetchChallengeCsvData = async (challengeId, challengeType,selectedOption = 'all', companyId) => {

    const isDummy = false;
    const endPoint = isDummy ? GetACMEChallengeCompetitors : GetChallengeCompetitors;
    // const isAdminPage = pathname?.includes('company');
    try {
      const res = await fetchApi(`${endPoint}/${challengeId}/${challengeType}?response_type=${selectedOption}${companyId ? `&company_id=${companyId}`: ''}`);
      if(res.message) {
        toast.error(res.message);
      } else {
        this.printAction(true,(res?.data?.[0] || res?.data?.participant_details) )
      }
    } catch(error) {
      toast.error(error.message);
      // dispatch(networkError(error.message));
    }

  }

  printAction = (bool,data) => {
    const { challenge} = this.props;
    const ChallengeType = challenge && challenge['event_type'].split(' ')[1];
    let updatedChallengeCSV = data && data?.length > 0 && challenge.challenge_type === 'new_group' ?
      data?.map((competitor) => {
        let obj = {};
        obj['FIRST NAME'] = competitor['fname'];
        obj['LAST NAME'] = competitor['lname'];
        obj['RANK'] = competitor['user_rank'];
        obj['EMAIL'] = competitor['EMAIL'];
        obj[`Total ${ChallengeType.charAt(0).toUpperCase()}${ChallengeType.slice(1)}`] = _.isNull(competitor[ChallengeType.toLowerCase()]) ? 0 : ChallengeType === 'Distance' ? `${getUnit(competitor[`${ChallengeType.toLowerCase()}`])} ${'miles'}` : commaSeperator(parseInt(competitor[`${ChallengeType.toLowerCase()}`],10));
        return obj;
      })
      : data?.map((competitor, index) => {
        let obj = {};
        obj['FIRST NAME'] = competitor['fname'];
        obj['LAST NAME'] = competitor['lname'];
        obj['RANK'] = index + 1;
        obj[`Total ${ChallengeType.charAt(0).toUpperCase()}${ChallengeType.slice(1)}`] = _.isNull(competitor[ChallengeType.toLowerCase()]) ? 0 : ChallengeType === 'Distance' ? `${getUnit(competitor[`${ChallengeType.toLowerCase()}`])} ${'miles'}` : commaSeperator(parseInt(competitor[`${ChallengeType.toLowerCase()}`],10));
        obj['Daily Average'] = challenge['challenge_type'] === 'group' ? competitor['daily_average'] : competitor['challenge_average'];
        obj['Weekly Average'] = _.isNull(competitor[ChallengeType.toLowerCase()]) ? 0 : commaSeperator(Math.round(competitor['weekly_average']));
        obj['No of Weeks Survived'] = challenge && challenge['challenge_type'] === 'survivor' && challenge['challenge_mode'] === 'Solo' && (!_.isNull(competitor['weekly_marks']) || !_.isUndefined(competitor['weekly_marks'])) ? competitor?.['weekly_marks']?.filter((item) => item !== 0).length : 0;
        obj['EMAIL'] = competitor['EMAIL'];
        obj['company_name'] = competitor['company_name'];
        obj['location'] = competitor['location'];
        return obj;
      });
    this.setState({ printChallengeCSV: bool, updatedChallengeCSV: updatedChallengeCSV })
  };

  getCSVHeaders = () => {
    const { challenge } = this.props;
    const ActivityType = challenge && challenge.event_type.split(' ')[1];
    const challengeType = challenge && challenge.challenge_type;
    if (challengeType === 'new_group') {
      csvHeaders = [
        { label: "First Name", key: "FIRST NAME" },
        { label: "Last Name", key: "LAST NAME" },
        { label: "Email", key: "EMAIL" },
        { label: "Rank", key: "RANK" },
      ];
    } else {
      csvHeaders = [
        { label: "First Name", key: "FIRST NAME" },
        { label: "Last Name", key: "LAST NAME" },
        { label: "Email", key: "EMAIL" },
        { label: "Location", key: "location" },
        { label: "Company Name", key: "company_name" },
        { label: "Rank", key: "RANK" },
        { label: "Daily Average", key: "Daily Average" },
        { label: "Weekly Average", key: "Weekly Average" },
      ];
    }
    csvHeaders.push({ label: `Total ${ActivityType}`, key: `Total ${ActivityType}` });
    challengeType === 'survivor' && challenge.challenge_mode === 'Solo' && csvHeaders.push({ label: "No of Weeks Survived", key: `No of Weeks Survived` });
    return csvHeaders;
  };

  onHideCustomNotification = () =>{
    this.setState({
      showCustomModel: false
    })
  }

  onHideAddUserPopup = () =>{
    this.setState({
      showAddUserPopup: false
    })
  }

  onAddUserPopup = (type, challenge) =>{
    this.setState({
      showAddUserPopup: true,
      popupType: type
    })
    if(challenge){
      this.setState({
        challengeType: challenge
      })
    }
  }

  render() {
    const { challenge, isLoading, comments, networkError, fetchChallengeCompetitors, location,
      postReplyOnComment, replySuccess, profileImage, userId, fetchTeamChallenge, role, updateDailyTask, syncTime, getUserOverviewDetails, getChallengeCsvData, challengeAttendees, userPermissions, user, teamChallenge, companyInfo} = this.props;
    const { comment, objIndex, taskUpdated, selectedDate, imgSrc, showVideo, joinOrLeave,exitChallenge, isButtonDisabled, tabValue,/* deleteChallengeId,*/ showDeletePopup, showLeavePopup, leaveChallengeId, printChallengeCSV, updatedChallengeCSV,showExitPopup, showCustomModel, showAddUserPopup, popupType, challengeType, hasCompanyInRoute} = this.state;
    if ((_.isNull(challenge) || _.isUndefined(challenge) || Object.keys(challenge).length === 0 || _.isNull(challenge['challenge_type']) || _.isUndefined(challenge['challenge_type']) || _.isNull(profileImage) || _.isNull(userId) || _.isNull(challengeAttendees)) && !networkError) {
      return <Waiting />
    }else if(challenge?.is_team_challenge){
      if (( _.isNull(teamChallenge) || _.isUndefined(teamChallenge['team_challenge_details']) || _.isUndefined(teamChallenge) || Object.keys(teamChallenge).length === 0 ) && !networkError) {
        return <Waiting />
      }

    }
    // const DistanceUnit = localStorage.getItem('DISTANCE');
    const fileTitle = challenge && challenge.title.replace(/ /g, "_");
    const isAdminPage = location?.pathname?.includes('company');
    const isSuperAdmin = role === "ADMIN";
    const companyId = isAdminPage || isSuperAdmin ? companyInfo?.id : user?.company_id;
    return (
      <React.Fragment>
        {(_.isNull(challenge) || _.isUndefined(challenge)) ? null :
          <Main>
            <LayoutNew display={(challenge.challenge_mode === 'Team' && challenge['challenge_type'] == 'survivor') ? "block" : "flex"}>
              <ChallengeGrid wrap="wrap">
                {challenge && challenge.challenge_type !== 'behavior'?
                  this.headerView():null}
                { tabValue===1 ? <div className="challengeTitle">{challenge.title}</div> : null}
                <div className="challengesCard">
                  <ChallengeInfoGridNew width={challenge['challenge_type'] == 'behavior' ? 1 : 0}>
                    {challenge && challenge.challenge_type !== 'behavior' && challenge.challenge_type !== 'new_group' && challenge.challenge_type !== 'group' && challenge.challenge_type !== 'survivor' ? 
                      <DetailedChallengeV2 role={role} userId={userId} isAdmin={role != 'USER'} challenge={challenge} navigateEdit={this.navigateEdit} syncTime={syncTime} userPermissions={userPermissions} /> 
                      :  challenge && challenge.challenge_type == 'behavior'? 
                        <BehaviorChallengeDetail challenge={challenge} />: tabValue===1 && 
                    <ChallengeDetailTop challenge={challenge} />}
                    {
                      challenge && challenge.challenge_type === 'survivor' ?
                        tabValue === 1 ?
                          <SurvivorOverViewScreen
                            challenge={challenge}
                            userId={userId}
                            profileImage={profileImage}
                            getUserOverviewDetails={getUserOverviewDetails}
                            location={location}
                            fetchTeamChallenge={fetchTeamChallenge}
                            getChallengeCsvData={getChallengeCsvData}
                            role={role}
                            userPermissions={userPermissions}
                            history={this.props.history}
                            // updateDownloadCSV={this.updateDownloadCSV}
                            printChallengeCSV={printChallengeCSV}
                            companyId={companyId}
                          /> :
                          tabValue === 2 ?
                            <>
                              {/* <SurvivorLeaderboard
                              challenge={challenge}
                              fetchChallengeCompetitors={fetchChallengeCompetitors}
                              location={location}
                              networkError={networkError}
                              userId={userId}
                              profileImage={profileImage}
                              fetchTeamChallenge={fetchTeamChallenge}
                            />  */}
                              <ChallengeLeaderBoard  
                                challenge={challenge}
                                location={location}
                                networkError={networkError}
                                userId={userId}
                                profileImage={profileImage}
                                fetchTeamChallenge={fetchTeamChallenge}
                                companyInfo={companyInfo}
                              />
                            </>
                            : 
                            tabValue === 3?
                              <FormContainer editChallenge={1} margin={1}  background={challenge.is_joined === 1&&challenge.challenge_status!="over"?0:1}>
                                <TopContainer border={challenge.is_joined === 1 && challenge.challenge_status!="over" ?0:1}>
                                  <h3>{this.props.t("Chat Group")}</h3>
                                  <div>
                                    {challengeAttendees.length > 0 && <img src={`${ImageUrl}/${challengeAttendees[0].profile_image}`} />}
                                    {challengeAttendees.length > 1 && <img src={`${ImageUrl}/${challengeAttendees[1].profile_image}`} />}
                                    {challengeAttendees.length > 2 && <img src={`${ImageUrl}/${challengeAttendees[2].profile_image}`} />}
                                    {challengeAttendees.length > 3 && <img src={`${ImageUrl}/${challengeAttendees[3].profile_image}`} />}
                                    {challengeAttendees.length > 4 && <img src={`${ImageUrl}/${challengeAttendees[4].profile_image}`} />}
                                    {challengeAttendees.length > 5 && <div>{challengeAttendees.length - 5}+</div>}
                                  </div>
                                </TopContainer>
                                <CommentContentContainer>
                                  {challenge.is_joined === 1&& challenge.challenge_status!="over" &&<FieldContainer>
                                    <CommentContent>
                                      <ImageWrapper isCommentSection borderRadius={"3px"} style={{borderRadius:'50%'}}>
                                        {this.showProfileImage()}
                                      </ImageWrapper>
                                      <CommentInnerContainer style={{border:'none'}}>
                                        <div style={{width:'530px',background:"#faf9f4",border:"1px solid #afcbd3",color:"#005c87", borderRadius:"20px", overflow:'auto'}}>
                                          {imgSrc && imgSrc.length >= 1 &&
                                          <InputImage className="InputImageSection">
                                            {imgSrc && imgSrc.length >= 1 ? <img src={imgSrc} alt="uploadable" /> : ''}
                                            {imgSrc && imgSrc.length >= 1 ? <button onClick={() => this.removeImage()}><span className="InputImageSpan">X</span></button> : ''}
                                          </InputImage>}
    
                                          <CommonTextArea
                                            placeholder={this.props.t("Write your comment here...")}
                                            onChange={(e) => this.onChange(e)}
                                            value={comment}
                                            rows={comment.length >= 120 ? "5" : "2"}
                                            data-gramm_editor="false"
                                            showEmojiPicker={this.showEmojiPicker}
                                            onClick={(e) => this.onChange(e)}
                                            style={{marginTop:"0px",display:'flex',alignItems:"center",background:"#faf9f4",border:"none",borderRadius:"20px",color:"#005c87",float:"inherit",padding:"14px 15px",paddingTop:comment.length == "" ? "20px" : "10px",paddingBottom:comment.length == "" ? '5px': '10px',placeholderColor:"#649bb3"}}
                                          />
                                        </div>
                                        <div style={{marginLeft:'15px',position:'relative'}}>
                                          {this.state.displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={this.onEmojiSelect} emojiRef={this.state.emojiRef} hidePicker={this.hideEmojiPicker}/> : null}
                                          <IconContainerNew cameraIcon style={{marginLeft:'15px',display:'flex',alignItems:'center',marginBottom:'4px'}}>
                                            <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Emoji"))}>
                                              <img style={{ marginLeft: "15px",marginTop:"10px",cursor: "pointer",width:"46px", height:"46px" }} onClick={this.showEmojiPicker} src={ImageUrl+"/images/new_emoji_icon.png"}></img>                                       
                                            </OverlayTrigger>
                                            <InputImageNew htmlFor="uploadPhoto" noMarginTop style={{background:"none",padding:'0px'}}>
                                              <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Attach photo"))}>
                                                <img src={ImageUrl+"/images/new_camera_icon.png"} style={{ marginLeft: "10px", cursor: "pointer",width:"46px", height:"46px" }} />
                                              </OverlayTrigger>
                                              <input
                                                id="uploadPhoto"
                                                type="file"
                                                name="image"
                                                accept=".jpeg, .png, .jpg*"
                                                multiple={false}
                                                onChange={(e) => this.onChangeImage(e)}
                                                onClick={(e) => e.target.files[0] && this.onChangeImage(e)}
                                              />
                                            </InputImageNew>
                                          </IconContainerNew>
                                        </div>
                                      </CommentInnerContainer>
                                    </CommentContent>
                                    {(comment || imgSrc.length >= 1) ? <PostButton color="#159fc9" style={{background:"#005c87",display:'flex',justifyContent:"center",alignItems:'center'}} onClick={() => this.postComment(challenge.id)}>{this.props.t("Post")} <img src='/public/images/SendPost.svg' /></PostButton> : null}
    
                                  </FieldContainer>}
                                  {(isLoading ? <Loading isHorizontal /> :
                                    (_.isEmpty(comments) ? <NoComments>{this.props.t("No comments to display")}</NoComments> :
                                      <BehaviorChallengeComments
                                        comments={comments}
                                        postReply={postReplyOnComment}
                                        id={challenge.id}
                                        replySuccess={replySuccess}
                                        history={this.props.history}
                                        isChallengeOrEvent={true}
                                      />
                                    )
                                  )}
                                </CommentContentContainer>
                              </FormContainer>:null: 
                        challenge.challenge_type === 'new_group' ?
                          tabValue === 1 ?
                            <GroupOverViewScreen
                              challenge={challenge}
                              userId={userId}
                              profileImage={profileImage}
                              getUserOverviewDetails={getUserOverviewDetails}
                              location={location}
                              fetchTeamChallenge={fetchTeamChallenge}
                              getChallengeCsvData={getChallengeCsvData}
                              role={role}
                              userPermissions={userPermissions}
                              history={this.props.history}
                              companyId={companyId}
                            />:
                            tabValue === 2 ?
                              <>
                                {/* <GroupChallengeLeaderboardV2
                                  challenge={challenge}
                                  location={location}
                                  networkError={networkError}
                                /> */}
                                <ChallengeLeaderBoard   
                                  challenge={challenge}
                                  location={location}
                                  networkError={networkError}
                                  userId={userId}
                                  profileImage={profileImage}
                                  fetchTeamChallenge={fetchTeamChallenge}
                                  companyInfo={companyInfo}
                                />
                              </>
                              :
                              tabValue === 3 ?        
                                <FormContainer editChallenge={1} margin={1} marginTop={1} background={challenge.is_joined === 1 && challenge.challenge_status!="over"?0:1}>
                                  <TopContainer border={challenge.is_joined === 1&&challenge.challenge_status!="over"?0:1}>
                                    <h3>{this.props.t("Chat Group")}</h3>
                                    <div>
                                      {challengeAttendees.length > 0 && <img src={`${ImageUrl}/${challengeAttendees[0].profile_image}`} />}
                                      {challengeAttendees.length > 1 && <img src={`${ImageUrl}/${challengeAttendees[1].profile_image}`} />}
                                      {challengeAttendees.length > 2 && <img src={`${ImageUrl}/${challengeAttendees[2].profile_image}`} />}
                                      {challengeAttendees.length > 3 && <img src={`${ImageUrl}/${challengeAttendees[3].profile_image}`} />}
                                      {challengeAttendees.length > 4 && <img src={`${ImageUrl}/${challengeAttendees[4].profile_image}`} />}
                                      {challengeAttendees.length > 5 && <div>{challengeAttendees.length - 5}+</div>}
                                    </div>
                                  </TopContainer>
                                  <CommentContentContainer>
                                    {challenge.is_joined === 1 &&challenge.challenge_status!="over"&&<FieldContainer>
                                      <CommentContent>
                                        <ImageWrapper isCommentSection borderRadius={"3px"} style={{borderRadius:'50%'}}>
                                          {this.showProfileImage()}
                                        </ImageWrapper>
                                        <CommentInnerContainer style={{border:'none'}}>
                                          <div style={{width:'530px',background:"#faf9f4",border:"1px solid #afcbd3",color:"#005c87", borderRadius:"20px", overflow:'auto'}}>
                                            {imgSrc && imgSrc.length >= 1 &&
                                          <InputImage className="InputImageSection">
                                            {imgSrc && imgSrc.length >= 1 ? <img src={imgSrc} alt="uploadable" /> : ''}
                                            {imgSrc && imgSrc.length >= 1 ? <button onClick={() => this.removeImage()}><span className="InputImageSpan">X</span></button> : ''}
                                          </InputImage>}
    
                                            <CommonTextArea
                                              placeholder={this.props.t("Write your comment here...")}
                                              onChange={(e) => this.onChange(e)}
                                              value={comment}
                                              rows={comment.length >= 120 ? "5" : "2"}
                                              data-gramm_editor="false"
                                              showEmojiPicker={this.showEmojiPicker}
                                              onClick={(e) => this.onChange(e)}
                                              style={{marginTop:"0px",display:'flex',alignItems:"center",background:"#faf9f4",border:"none",borderRadius:"20px",color:"#005c87",float:"inherit",padding:"14px 15px",paddingTop:comment.length == "" ? "20px" : "10px",paddingBottom:comment.length == "" ? '5px': '10px',placeholderColor:"#649bb3"}}
                                            />
                                          </div>
                                          <div style={{marginLeft:'15px',position:'relative'}}>
                                            {this.state.displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={this.onEmojiSelect} emojiRef={this.state.emojiRef} hidePicker={this.hideEmojiPicker}/> : null}
                                            <IconContainerNew cameraIcon style={{marginLeft:'15px',display:'flex',alignItems:'center',marginBottom:'4px'}}>
                                              <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Emoji"))}>
                                                <img style={{ marginLeft: "15px",marginTop:"10px",cursor: "pointer",width:"46px", height:"46px" }} onClick={this.showEmojiPicker} src={ImageUrl+"/images/new_emoji_icon.png"}></img>                                       
                                              </OverlayTrigger>                                          
                                              <InputImageNew htmlFor="uploadPhoto" noMarginTop style={{background:"none",padding:'0px'}}>
                                                <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Attach photo"))}>
                                                  <img src={ImageUrl+"/images/new_camera_icon.png"} style={{ marginLeft: "10px", cursor: "pointer",width:"46px", height:"46px" }} />
                                                </OverlayTrigger>
                                                <input
                                                  id="uploadPhoto"
                                                  type="file"
                                                  name="image"
                                                  accept=".jpeg, .png, .jpg*"
                                                  multiple={false}
                                                  onChange={(e) => this.onChangeImage(e)}
                                                  onClick={(e) => e.target.files[0] && this.onChangeImage(e)}
                                                />
                                              </InputImageNew>
                                            </IconContainerNew>
                                          </div>
                                        </CommentInnerContainer>
                                      </CommentContent>
                                      {(comment || imgSrc.length >= 1) ? <PostButton color="#159fc9" style={{background:"#005c87",display:'flex',justifyContent:"center",alignItems:'center'}} onClick={() => this.postComment(challenge.id)}>{this.props.t("Post")} <img src='/public/images/SendPost.svg' /></PostButton> : null}
                                    </FieldContainer>}
                                    {(isLoading ? <Loading isHorizontal /> :
                                      (_.isEmpty(comments) ? <NoComments>{this.props.t("No comments to display")}</NoComments> :
                                        <BehaviorChallengeComments
                                          comments={comments}
                                          postReply={postReplyOnComment}
                                          id={challenge.id}
                                          replySuccess={replySuccess}
                                          history={this.props.history}
                                          isChallengeOrEvent={true}
                                        />
                                      )
                                    )}
                                  </CommentContentContainer>
                                </FormContainer>:null  :    
                          challenge && challenge.challenge_type == 'group' && challenge.is_team_challenge !== 1 ?
                            tabValue === 1 ?
                              <GroupOverViewScreen
                                challenge={challenge}
                                userId={userId}
                                profileImage={profileImage}
                                getUserOverviewDetails={getUserOverviewDetails}
                                location={location}
                                fetchTeamChallenge={fetchTeamChallenge}
                                getChallengeCsvData={getChallengeCsvData}
                                role={role}
                                userPermissions={userPermissions}
                                history={this.props.history}
                                companyId={companyId}
                              />:
                              tabValue === 2 ?
                                <>
                                  {/* <ClassicChallengeLeaderboard
                                    challenge={challenge}
                                    fetchChallengeCompetitors={fetchChallengeCompetitors}
                                    location={location}
                                    networkError={networkError}
                                    userId={userId}
                                    profileImage={profileImage}
                                    fetchTeamChallenge={fetchTeamChallenge}
                                  /> */}
                                  <ChallengeLeaderBoard                             
                                    challenge={challenge}
                                    fetchChallengeCompetitors={fetchChallengeCompetitors}
                                    location={location}
                                    networkError={networkError}
                                    userId={userId}
                                    profileImage={profileImage}
                                    fetchTeamChallenge={fetchTeamChallenge}
                                    companyInfo={companyInfo}
                                  />
                                </>
                                :
                                tabValue === 3?
                                  <FormContainer editChallenge={1} margin={1} marginTop={1} background={challenge.is_joined === 1&&challenge.challenge_status!="over"?0:1}>
                                    <TopContainer border={challenge.is_joined === 1&&challenge.challenge_status!="over"?0:1}>
                                      <h3>{this.props.t("Chat Group")}</h3>
                                      <div>
                                        {challengeAttendees.length > 0 && <img src={`${ImageUrl}/${challengeAttendees[0].profile_image}`} />}
                                        {challengeAttendees.length > 1 && <img src={`${ImageUrl}/${challengeAttendees[1].profile_image}`} />}
                                        {challengeAttendees.length > 2 && <img src={`${ImageUrl}/${challengeAttendees[2].profile_image}`} />}
                                        {challengeAttendees.length > 3 && <img src={`${ImageUrl}/${challengeAttendees[3].profile_image}`} />}
                                        {challengeAttendees.length > 4 && <img src={`${ImageUrl}/${challengeAttendees[4].profile_image}`} />}
                                        {challengeAttendees.length > 5 && <div>{challengeAttendees.length - 5}+</div>}
                                      </div>
    
                                    </TopContainer>
                                    <CommentContentContainer>
                                      { challenge.is_joined === 1 && challenge.challenge_status!="over"&&<FieldContainer>
                                        <CommentContent>
                                          <ImageWrapper isCommentSection borderRadius={"3px"}>
                                            {this.showProfileImage()}
                                          </ImageWrapper>
                                          <CommentInnerContainer style={{border:'none'}}>
                                            <div style={{width:'530px',background:"#faf9f4",border:"1px solid #afcbd3",color:"#005c87", borderRadius:"20px", overflow:'auto'}}>
                                              {imgSrc && imgSrc.length >= 1 &&
                                              <InputImage className="InputImageSection">
                                                {imgSrc && imgSrc.length >= 1 ? <img src={imgSrc} alt="uploadable" /> : ''}
                                                {imgSrc && imgSrc.length >= 1 ? <button onClick={() => this.removeImage()}><span className="InputImageSpan">X</span></button> : ''}
                                              </InputImage>}
    
                                              <CommonTextArea
                                                placeholder={this.props.t("Write your comment here...")}
                                                onChange={(e) => this.onChange(e)}
                                                value={comment}
                                                rows={comment.length >= 120 ? "5" : "2"}
                                                data-gramm_editor="false"
                                                showEmojiPicker={this.showEmojiPicker}
                                                onClick={(e) => this.onChange(e)}
                                                style={{marginTop:"0px",display:'flex',alignItems:"center",background:"#faf9f4",border:"none",borderRadius:"20px",color:"#005c87",float:"inherit",padding:"14px 15px",paddingTop:comment.length == "" ? "20px" : "10px",paddingBottom:comment.length == "" ? '5px': '10px',placeholderColor:"#649bb3"}}
                                              />
                                            </div>
                                            <div style={{marginLeft:'15px',position:'relative'}}>
                                              {this.state.displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={this.onEmojiSelect} emojiRef={this.state.emojiRef} hidePicker={this.hideEmojiPicker}/> : null}
                                              <IconContainerNew cameraIcon style={{marginLeft:'15px',display:'flex',alignItems:'center',marginBottom:'4px'}}>
                                                <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Emoji"))}>
                                                  <img style={{ marginLeft: "15px",marginTop:"10px", cursor: "pointer",width:"46px", height:"46px" }} onClick={this.showEmojiPicker} src={ImageUrl+"/images/new_emoji_icon.png"}></img>
                                                </OverlayTrigger>                                             
                                                <InputImageNew htmlFor="uploadPhoto" noMarginTop style={{background:"none",padding:'0px'}}>
                                                  <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Attach photo"))}>
                                                    <img src={ImageUrl+"/images/new_camera_icon.png"} style={{ marginLeft: "10px", cursor: "pointer",width:"46px", height:"46px" }}/>
                                                  </OverlayTrigger>  
                                                  <input
                                                    id="uploadPhoto"
                                                    type="file"
                                                    name="image"
                                                    accept=".jpeg, .png, .jpg*"
                                                    multiple={false}
                                                    onChange={(e) => this.onChangeImage(e)}
                                                    onClick={(e) => e.target.files[0] && this.onChangeImage(e)}
                                                  />
                                                </InputImageNew>
                                              </IconContainerNew>
                                            </div>
                                          </CommentInnerContainer>
                                        </CommentContent>
                                        {(comment || imgSrc.length >= 1) ? <PostButton  style={{background:"#005c87",display:'flex',justifyContent:"center",alignItems:'center'}} color="#159fc9" onClick={() => this.postComment(challenge.id)}>{this.props.t("Post")} <img src='/public/images/SendPost.svg' /></PostButton> : null}
                                      </FieldContainer> }
                                      {(isLoading ? <Loading isHorizontal /> :
                                        (_.isEmpty(comments) ? <NoComments>{this.props.t("No comments to display")}</NoComments> :
                                          <BehaviorChallengeComments
                                            comments={comments}
                                            postReply={postReplyOnComment}
                                            id={challenge.id}
                                            replySuccess={replySuccess}
                                            history={this.props.history}
                                            isChallengeOrEvent={true}
                                          />
                                        )
                                      )}
                                    </CommentContentContainer>
                                  </FormContainer>:null                  
                            : 
                            challenge && challenge.challenge_type == 'behavior' ?
                              <StyledTabsNew defaultActiveKey={1} id="styledTabs" style={{ display: "flex", background:"white", padding:"10px 15px" }}>
                                <Tab eventKey={1} title={this.props.t("Overview")} tabClassName="first-tab">
                                  {
                                    <MyTaskTabV2
                                      challenge={challenge}
                                      userId={userId}
                                      profileImage={profileImage}
                                      location={location}
                                      role={role}
                                      history={this.props.history}
                                      updateDailyTask={updateDailyTask}
                                      setObjIndex={this.setObjIndex}
                                      objIndex={objIndex}
                                      taskUpdated={taskUpdated}
                                      selectedDate={selectedDate}
                                      userPermissions={userPermissions}
                                    />
                                  }
                                </Tab>
                                {
                                  <Tab eventKey={2} title={this.props.t("Progress")} tabClassName="second-tab">
                                    {
                                      <MyProgressTab
                                        challenge={challenge}
                                        location={location}
                                        networkError={networkError}
                                        userId={userId}
                                        profileImage={profileImage}
                                      />
                                    }
                                  </Tab>
                                }
                                {challenge && challenge['challenge_type'] == 'behavior' && (challenge.challenge_status === 'joined'||challenge.challenge_status === 'over') &&
                                  <Tab eventKey={3} title={this.props.t("Chat")} tabClassName="third-tab">
                                    {<FormContainer editChallenge={1} margin={1} marginTop={1}>
                                      <TopContainer>
                                        <h3>{this.props.t("Chat Group")}</h3>
                                        <div>
                                          {challengeAttendees.length > 0 && <img src={`${ImageUrl}/${challengeAttendees[0].profile_image}`} />}
                                          {challengeAttendees.length > 1 && <img src={`${ImageUrl}/${challengeAttendees[1].profile_image}`} />}
                                          {challengeAttendees.length > 2 && <img src={`${ImageUrl}/${challengeAttendees[2].profile_image}`} />}
                                          {challengeAttendees.length > 3 && <img src={`${ImageUrl}/${challengeAttendees[3].profile_image}`} />}
                                          {challengeAttendees.length > 4 && <img src={`${ImageUrl}/${challengeAttendees[4].profile_image}`} />}
                                          {challengeAttendees.length > 5 && <div>{challengeAttendees.length - 5}+</div>}
                                        </div>
    
                                      </TopContainer>
                                      <CommentContentContainer>
                                        <FieldContainer>
                                          <CommentContent>
                                            <ImageWrapper isCommentSection borderRadius={"3px"}>
                                              {this.showProfileImage()}
                                            </ImageWrapper>
                                            <CommentInnerContainer style={{border:'none'}}>
                                              <div style={{width:'530px',background:"#faf9f4",border:"1px solid #afcbd3",color:"#005c87", borderRadius:"20px", overflow:'auto'}}>
                                                {imgSrc && imgSrc.length >= 1 &&
                                                <InputImage className="InputImageSection">
                                                  {imgSrc && imgSrc.length >= 1 ? <img src={imgSrc} alt="uploadable" /> : ''}
                                                  {imgSrc && imgSrc.length >= 1 ? <button onClick={() => this.removeImage()}><span className="InputImageSpan">X</span></button> : ''}
                                                </InputImage>}
    
                                                <CommonTextArea
                                                  placeholder={this.props.t("Write your comment here...")}
                                                  onChange={challenge.challenge_status === 'over'?null: (e) => this.onChange(e)}
                                                  value={comment}
                                                  rows={comment.length >= 120 ? "5" : "2"}
                                                  data-gramm_editor="false"
                                                  showEmojiPicker={this.showEmojiPicker}
                                                  onClick={(e) => this.onChange(e)}
                                                  style={{marginTop:"0px",display:'flex',alignItems:"center",background:"#faf9f4",border:"none",borderRadius:"20px",color:"#005c87",float:"inherit",padding:"12px",placeholderColor:"#649bb3", cursor:challenge.challenge_status === 'over'?"not-allowed":"pointer"}}
                                                />
                                              </div>
                                              <div style={{marginLeft:'15px',position:'relative'}}>
                                                {this.state.displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={this.onEmojiSelect} emojiRef={this.state.emojiRef} hidePicker={this.hideEmojiPicker}/> : null}
    
                                                <IconContainerNew cameraIcon style={{marginLeft:'15px',display:'flex',alignItems:'center',marginBottom:'4px'}}>
                                                  <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Emoji"))}>
                                                    <img style={{ marginLeft: "15px",marginTop:"10px",cursor: "pointer",width:"46px", height:"46px" }} onClick={challenge.challenge_status === 'over'?null:()=>this.showEmojiPicker()} src={ImageUrl+"/images/new_emoji_icon.png"}></img>
                                                  </OverlayTrigger>
                                                  <InputImageNew htmlFor="uploadPhoto" noMarginTop style={{background:"none",padding:'0px'}}>
                                                    <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Attach photo"))}>
                                                      <img src={ImageUrl+"/images/new_camera_icon.png"} style={{ marginLeft: "10px", cursor: "pointer",width:"46px", height:"46px" }} />
                                                    </OverlayTrigger>
                                                    <input
                                                      id="uploadPhoto"
                                                      type="file"
                                                      name="image"
                                                      accept=".jpeg, .png, .jpg*"
                                                      multiple={false}
                                                      onChange={challenge.challenge_status === 'over'?null:(e) => this.onChangeImage(e)}
                                                      onClick={challenge.challenge_status === 'over'?null:(e) => e.target.files[0] && this.onChangeImage(e)}
                                                    />
                                                  </InputImageNew>
                                                </IconContainerNew>
                                              </div>
                                            </CommentInnerContainer>
                                          </CommentContent>
                                          {(comment || imgSrc.length >= 1) ? <PostButton color="#159fc9" style={{background:"#005c87",display:'flex',justifyContent:"center",alignItems:'center'}} onClick={() => this.postComment(challenge.id)}>{this.props.t("Post")} <img src='/public/images/SendPost.svg' /></PostButton> : null}
                                        </FieldContainer>
                                        {(isLoading ? <Loading isHorizontal /> :
                                          (_.isEmpty(comments) ? <NoComments>{this.props.t("No comments to display")}</NoComments> :
                                            <BehaviorChallengeComments
                                              comments={comments}
                                              postReply={postReplyOnComment}
                                              id={challenge.id}
                                              replySuccess={replySuccess}
                                              history={this.props.history}
                                              isChallengeOrEvent={true}
                                            />
                                          )
                                        )}
                                      </CommentContentContainer>
                                    </FormContainer>
                                    }
                                  </Tab>
                                }
                              </StyledTabsNew> :
                              //Team Challenge detail tabs starts
                              challenge && challenge.challenge_type == 'group' && challenge.is_team_challenge === 1 ?
                                tabValue === 1 ?
                                  <TeamOverview
                                    challenge={challenge}
                                    teamChallenge={teamChallenge}
                                    userId={userId}
                                    profileImage={profileImage}
                                    getUserOverviewDetails={getUserOverviewDetails}
                                    location={location}
                                    fetchTeamChallenge={fetchTeamChallenge}
                                    fetchChallengeCompetitors={fetchChallengeCompetitors}
                                    getChallengeCsvData={getChallengeCsvData}
                                    role={role}
                                    userPermissions={userPermissions}
                                    history={this.props.history}
                                    user={user}
                                    networkError={networkError}
                                    companyId={companyId}
                                  />
                                  :
                                  tabValue === 2 ?
                                    <>
                                      {/* <TeamLeaderboard
                                        challenge={challenge}
                                        teamChallenge={teamChallenge}
                                        fetchChallengeCompetitors={fetchChallengeCompetitors}
                                        location={location}
                                        networkError={networkError}
                                        userId={userId}
                                        profileImage={profileImage}
                                        fetchTeamChallenge={fetchTeamChallenge}
                                      /> */}
      
                                      <ChallengeLeaderBoard
                                        challenge={challenge}
                                        teamChallenge={teamChallenge}
                                        fetchChallengeCompetitors={fetchChallengeCompetitors}
                                        location={location}
                                        networkError={networkError}
                                        userId={userId}
                                        profileImage={profileImage}
                                        fetchTeamChallenge={fetchTeamChallenge}
                                        companyInfo={companyInfo}
                                      />
                                    
                                    </>
                                    :
                                    tabValue === 3 ?
                                      <FormContainer editChallenge={1} margin={1} marginTop={1} background={challenge.is_joined === 1&&challenge.challenge_status!="over"?0:1}>
                                        <TopContainer border={challenge.is_joined === 1&&challenge.challenge_status!="over"?0:1}>
                                          <h3>{this.props.t("Chat Group")}</h3>
                                          <div>
                                            {challengeAttendees.length > 0 && <img src={`${ImageUrl}/${challengeAttendees[0].profile_image}`} />}
                                            {challengeAttendees.length > 1 && <img src={`${ImageUrl}/${challengeAttendees[1].profile_image}`} />}
                                            {challengeAttendees.length > 2 && <img src={`${ImageUrl}/${challengeAttendees[2].profile_image}`} />}
                                            {challengeAttendees.length > 3 && <img src={`${ImageUrl}/${challengeAttendees[3].profile_image}`} />}
                                            {challengeAttendees.length > 4 && <img src={`${ImageUrl}/${challengeAttendees[4].profile_image}`} />}
                                            {challengeAttendees.length > 5 && <div>{challengeAttendees.length - 5}+</div>}
                                          </div>
                                        </TopContainer>
                                        <CommentContentContainer>
                                          {challenge.is_joined === 1 &&challenge.challenge_status!="over"&&<FieldContainer>
                                            {this.state.displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={this.onEmojiSelect} emojiRef={this.state.emojiRef} hidePicker={this.hideEmojiPicker}/> : null}
                                            <CommentContent>
                                              <ImageWrapper isCommentSection borderRadius={"3px"}>
                                                {this.showProfileImage()}
                                              </ImageWrapper>
                                              <CommentInnerContainer style={{border:'none'}}>
                                                <div style={{width:'530px',background:"#faf9f4",border:"1px solid #afcbd3",color:"#005c87", borderRadius:"20px", overflow:'auto'}}>
                                                  {imgSrc && imgSrc.length >= 1 &&
                                              <InputImage className="InputImageSection">
                                                {imgSrc && imgSrc.length >= 1 ? <img src={imgSrc} alt="uploadable" /> : ''}
                                                {imgSrc && imgSrc.length >= 1 ? <button onClick={() => this.removeImage()}><span className="InputImageSpan">X</span></button> : ''}
                                              </InputImage>}
    
                                                  <CommonTextArea
                                                    placeholder={this.props.t("Write your comment here...")}
                                                    onChange={(e) => this.onChange(e)}
                                                    value={comment}
                                                    rows={comment.length >= 120 ? "5" : "2"}
                                                    data-gramm_editor="false"
                                                    showEmojiPicker={this.showEmojiPicker}
                                                    onClick={(e) => this.onChange(e)}
                                                    style={{marginTop:"0px",display:'flex',alignItems:"center",background:"#faf9f4",border:"none",borderRadius:"20px",color:"#005c87",float:"inherit",padding:"14px 15px",paddingTop:comment.length == "" ? "20px" : "10px",paddingBottom:comment.length == "" ? '5px': '10px',placeholderColor:"#649bb3"}}
                                                  />
                                                </div>
                                                <div style={{marginLeft:'15px',position:'relative'}}>
                                                  <IconContainerNew cameraIcon style={{marginLeft:'15px',display:'flex',alignItems:'center',marginBottom:'4px'}}>
                                                    <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Emoji"))}>
                                                      <img style={{ marginLeft: "15px",marginTop:"10px",cursor: "pointer",width:"46px", height:"46px" }} onClick={this.showEmojiPicker} src={ImageUrl+"/images/new_emoji_icon.png"}></img>                                       
                                                    </OverlayTrigger>                                           
                                                    <InputImageNew htmlFor="uploadPhoto" noMarginTop style={{background:"none",padding:'0px'}}>
                                                      <OverlayTrigger placement="bottom" overlay={this.popover(this.props.t("Attach photo"))}>
                                                        <img src={ImageUrl+"/images/new_camera_icon.png"} style={{ marginLeft: "10px", cursor: "pointer",width:"46px", height:"46px" }} />
                                                      </OverlayTrigger>
                                                      <input
                                                        id="uploadPhoto"
                                                        type="file"
                                                        name="image"
                                                        accept=".jpeg, .png, .jpg*"
                                                        multiple={false}
                                                        onChange={(e) => this.onChangeImage(e)}
                                                        onClick={(e) => e.target.files[0] && this.onChangeImage(e)}
                                                      />
                                                    </InputImageNew>
                                                  </IconContainerNew>
                                                </div>
                                              </CommentInnerContainer>
                                            </CommentContent>
                                            {(comment || imgSrc.length >= 1) ? <PostButton color="#159fc9" style={{background:"#005c87",display:'flex',justifyContent:"center",alignItems:'center'}} onClick={() => this.postComment(challenge.id)}>{this.props.t("Post")} <img src='/public/images/SendPost.svg' /></PostButton> : null}
                                          </FieldContainer>}
                                          {(isLoading ? <Loading isHorizontal /> :
                                            (_.isEmpty(comments) ? <NoComments>{this.props.t("No comments to display")}</NoComments> :
                                              <BehaviorChallengeComments
                                                comments={comments}
                                                postReply={postReplyOnComment}
                                                id={challenge.id}
                                                replySuccess={replySuccess}
                                                history={this.props.history}
                                                isChallengeOrEvent={true}
                                              />
                                            )
                                          )}
                                        </CommentContentContainer>
                                      </FormContainer>:null:null}
                  </ChallengeInfoGridNew>
                  {
                    challenge ? <RightContainer margin={(challenge['challenge_type'] === 'behavior' || challenge['challenge_type'] === 'new_group' || challenge['challenge_type'] === 'group' || challenge['challenge_type'] === 'survivor') ? "0px" : "0px"}>
                      {challenge && challenge['challenge_type'] == 'behavior' &&
                      <RightSideSection
                        challenge={challenge}
                        userId={userId}
                        profileImage={profileImage}
                        location={location}
                        role={role}
                        history={this.props.history}
                        updateDailyTask={updateDailyTask}
                        setObjIndex={this.setObjIndex}
                        objIndex={objIndex}
                        taskUpdated={taskUpdated}
                        selectedDate={selectedDate}
                        userPermissions={userPermissions}
                      />}
                      <CommentGridNew width={challenge && challenge['challenge_type'] == 'behavior' ? 1 : 0}>
                        {<div className="contents-top">
                          {challenge.challenge_type === 'behavior' && challenge.challenge_status !== 'over' ?
                            <ButtonContainer>
                              {challenge.is_joined === 1 ?null:
                                <EventsButton backgroundColor={"#005C87"} color={"white"} onClick={isButtonDisabled?null:() => this.joinChallenge(challenge.id, joinOrLeave)} padding={'15px 8px 15px 8px'} font={"18px"} margin={"25px"} boxShadow="0px 8px 24px 0px #005C8780">
                                  {this.props.t("Join Challenge")}
                                </EventsButton>}
                              {!_.isNull(challenge.introduction_video) &&
                                <EventsButton backgroundColor={"linear-gradient(90deg,rgb(0,177,188) -1.11%,rgb(117,217,163) 97.46%)"} onClick={this.changeModal} padding={'15px 8px 15px 8px'} font={"18px"}>
                                  {this.props.t("Play Intro Video")}
                                </EventsButton>}
                            </ButtonContainer> : null}
                          {challenge && challenge.challenge_status === 'over' && challenge.challenge_type === 'behavior' &&
                          <EventsButton backgroundColor={'#f6dfd8'} color={"#005C87"} padding={'15px 8px 15px 8px'} font={"18px"} cursor={"1"}>
                            {this.props.t("Challenge Completed")}
                          </EventsButton>}
                          {/* {challenge && challenge.challenge_status === 'over' && challenge['challenge_type'] !== 'behavior' && (DistanceUnit === "KILOMETER" ? <CompletedChallengeCard dangerouslySetInnerHTML={{ __html: challenge.metric_message }} /> : <CompletedChallengeCard dangerouslySetInnerHTML={{ __html: challenge.message }} />)} */}
                          {challenge && (challenge['challenge_type'] == 'behavior') &&
                          <AboutContainer marginTop={'0px 0px 15px 0px'} color={"#0D4270"}>
                            <div>{this.props.t("About The Challenge")}</div>
                            <div >{parse(challenge.body)}</div>
                          </AboutContainer>}
                          {/* {challenge.is_joined === 1 && challenge.challenge_type === 'behavior'?
                          <EventsButton backgroundColor={"#005C870D"} color={"#005C87"} padding={'15px 8px 15px 8px'} font={"18px"} cursor={"1"} margin={"25px"}>
                            {"You Joined This Challenge"}
                          </EventsButton>:null}   */}
                          {showVideo && !_.isNull(challenge.introduction_video) && !_.isNull(challenge.video_title) && <DemoPopup showModal={showVideo} onClose={this.changeModal} videoUrl={challenge.introduction_video} VideoTitle={challenge.video_title} />}
                          {challenge && challenge['challenge_type'] == 'behavior' || challenge['challenge_type'] === 'new_group' || challenge['challenge_type'] === 'group' || challenge['challenge_type'] === 'survivor' ? null :
                            <CommentContentContainer>
                              <ChatGroup width={challenge && challenge['challenge_type'] == 'behavior' ? "100%" : "65%"}>
                                <div>
                                  <span>{this.props.t("Chat Group")}</span>
                                  <div>{challenge.is_dummy_challenge === 1 ? '6320' : challengeAttendees.length} <span>{challengeAttendees.length > 1 ? 'Members' : 'Member'}</span></div>
                                </div>
                                <ChatUsers>
                                  {this.getListOfUser()}
                                </ChatUsers>
                              </ChatGroup>
                              <FieldContainer commentsSection border={1}>
                                <ChatCommentContent>
                                  <ChatTextArea
                                    placeholder={this.props.t("Write your comment here...")}
                                    rows={1}
                                    onChange={(e) => this.onChange(e)}
                                    value={comment}
                                    data-gramm_editor="false"
                                    showEmojiPicker={this.showEmojiPicker}
                                    onClick={(e) => this.onChange(e)}
                                    style={{paddingRight:"100px"}}
                                  />
                                  {this.state.displayEmoji ? <SocialFeedsEmojiPicker selectEmoji={this.onEmojiSelect} emojiRef={this.state.emojiRef} hidePicker={this.hideEmojiPicker}/> : null}
                                  <div className="InputImageSection">
                                    {imgSrc && imgSrc.length >= 1 ? <img src={imgSrc} alt="uploadable" /> : ''}
                                    {imgSrc && imgSrc.length >= 1 ? <button onClick={() => this.removeImage()}>X</button> : ''}
                                  </div>
                                  <IconContainer cameraIcon>
                                    <img style={{ marginTop: '8px', cursor: 'pointer'}} onClick={this.showEmojiPicker} src='/public/images/emoji_icon.svg'></img>                                  
                                    <InputImage htmlFor="uploadPhoto" noMarginTop>
                                      <i className="fas fa-camera" />
                                      <input
                                        id="uploadPhoto"
                                        type="file"
                                        name="image"
                                        accept=".jpeg, .png, .jpg*"
                                        multiple={false}
                                        onChange={(e) => this.onChangeImage(e)}
                                        onClick={(e) => e.target.files[0] && this.onChangeImage(e)}
                                      />
                                    </InputImage>
                                  </IconContainer>
                                  {comment || imgSrc.length >= 1 ? <span onClick={() => this.postComment(challenge.id)} disabled={!comment.trim()}>
                                    <img src={'/public/images/ClassicChallengeV2/send-button.png'} alt={'post'} />
                                  </span> : ''}
                                </ChatCommentContent>
                              </FieldContainer>
                              {(isLoading ? <Loading isHorizontal /> :
                                (_.isEmpty(comments) ? <NoComments>{this.props.t("No comments to display")}</NoComments> :
                                  <CommentsV2
                                    comments={comments}
                                    postReply={postReplyOnComment}
                                    id={challenge.id}
                                    replySuccess={replySuccess}
                                    history={this.props.history}
                                    isChallengeOrEvent={true}
                                  />
                                )
                              )}
                            </CommentContentContainer>}
                          {challenge && (challenge['challenge_type'] === 'survivor') &&  <SurvivorRightScreen  tabValue={tabValue} userId={userId} challenge={challenge}  history={this.props.history} onAddUserPopup={this.onAddUserPopup} getUserOverviewDetails={getUserOverviewDetails} role={role} hasCompanyInRoute={hasCompanyInRoute} companyId={companyId}/>}
                          {/* <SurvivorRightSection
                            challenge={challenge}
                            userId={userId}
                            profileImage={profileImage}
                            getUserOverviewDetails={getUserOverviewDetails}
                            location={location}
                            networkError={networkError}
                            history={this.props.history}
                            role={role}
                          /> */}
                        
                          {challenge && (challenge['challenge_type'] === 'new_group') &&  <CharityChallengeRightScreen tabValue={tabValue}  userId={userId} challenge={challenge}  history={this.props.history} onAddUserPopup={this.onAddUserPopup} getUserOverviewDetails={getUserOverviewDetails} role={role} hasCompanyInRoute={hasCompanyInRoute} companyId={companyId}/>}
                          {/* <GroupRightSection
                          challenge={challenge}
                          userId={userId}
                          profileImage={profileImage}
                          getUserOverviewDetails={getUserOverviewDetails}
                          location={location}
                          networkError={networkError}
                          history={this.props.history}
                          role={role}
                        /> */}
                          
                          {challenge && (challenge['challenge_type'] === 'group')&& challenge.is_team_challenge !== 1 &&   <ClassicRightScreen  tabValue={tabValue} userId={userId} challenge={challenge}  history={this.props.history} onAddUserPopup={this.onAddUserPopup} getUserOverviewDetails={getUserOverviewDetails} role={role} hasCompanyInRoute={hasCompanyInRoute} companyId={companyId}/>}
                          {/* <ClassicRightSection
                          challenge={challenge}
                          userId={userId}
                          profileImage={profileImage}
                          getUserOverviewDetails={getUserOverviewDetails}
                          location={location}
                          networkError={networkError}
                          history={this.props.history}
                          role={role}
                          fetchChallengeCompetitors={fetchChallengeCompetitors}
                        /> */}
                        
                         
                          {challenge && (challenge['challenge_type'] === 'group') && challenge.is_team_challenge === 1 &&
                          <ClassicTeamRightScreen
                            challenge={challenge}
                            teamChallenge={teamChallenge}
                            userId={userId}
                            tabValue={tabValue}
                            profileImage={profileImage}
                            getUserOverviewDetails={getUserOverviewDetails}
                            location={location}
                            networkError={networkError}
                            history={this.props.history}
                            fetchChallengeCompetitors={fetchChallengeCompetitors}
                            role={role}
                            user={user}
                            hasCompanyInRoute={hasCompanyInRoute}
                            onAddUserPopup={this.onAddUserPopup}
                            companyId={companyId}
                          />
                          }
                          {/* <TeamChallengeRight
                            challenge={challenge}
                            teamChallenge={teamChallenge}
                            userId={userId}
                            profileImage={profileImage}
                            getUserOverviewDetails={getUserOverviewDetails}
                            location={location}
                            networkError={networkError}
                            history={this.props.history}
                            role={role}
                            fetchChallengeCompetitors={fetchChallengeCompetitors}
                            user={user}
                          /> */}
                          
                          
                        </div>}
                      </CommentGridNew></RightContainer> : null
                  }
                </div>
              </ChallengeGrid>
              {/* <StartChallengePopUp onClose={this.props.setChallengeInviteStatus} showModal={this.props.inviteAmigoStatus} userName={user['fname']} challenge={challenge} history={this.props.history} inviteAmigoStatus={1} /> */}
              {/* {showDeletePopup&& 
                <DeleteAndLeavePopup
                  leaveId={leaveChallengeId}
                  deleteId={deleteChallengeId}
                  showConfirmPopupDelete={showDeletePopup}
                  showConfirmPopup={showLeavePopup}
                  showHideDeletePopup={this.hideDeletePopup}
                  showHideLeavePopup={this.hideLeavePopup}
                  deleteData={this.deleteTeam}
                  leaveData={this.leaveTeam}
                  userName={user && user.fname}
                  showDelete={true}
                />} */}
              {showDeletePopup&&<DeletePopup
                showModal={showDeletePopup}
                onClose={this.hideDeletePopup}
                deleteConsumer={this.deleteTeam}
                type="challenge"
              />}  
              {showLeavePopup&& 
                <DeleteAndLeavePopup
                  leaveId={leaveChallengeId}
                  showConfirmPopup={showLeavePopup}
                  showHideLeavePopup={this.hideLeavePopup}
                  leaveData={this.leaveTeam}
                  userName={user && user.fname}
                />}
              {showExitPopup && <CommonModal
                show={showExitPopup}
                icon={RecognitionWarningIcon("#CE7841")}
                title="Exit Challenge"
                description="Are you sure you want to exit this challenge?"
                descriptionColor="#CE7841"
                subDescription="This will reset your progress and remove all your challenge activity. This action cannot be undone."
                onCancel={this.hideExitChallenge}
                onConfirm={() =>this.joinChallenge(challenge.id, exitChallenge)}
                cancelText="Stay in Challenge"
                confirmButtonText="Exit Challenge"
                buttonIcon={ExitChallenge("white")}
                confirmButtonWidth="198px"
                modalHeight="275px"
                isFontSize="16px"
              />
              }
              <Suspense fallback={<Waiting/>}>
                <InviteAmigoPopUp userId={userId} history={this.props.history} showModal={this.state.showInviteAmigoPopup} hideInviteAmigoPopup={this.showHideInviteAmigoPopup} onHide={this.showHideInviteAmigoPopup} challengeId={challenge.id} plusAmigoButton={1}/></Suspense>  
              {printChallengeCSV && <CSVList Title={`${fileTitle}_${challenge && challenge.id}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={updatedChallengeCSV} />}
              {showCustomModel&&<CustomNotification onClose={this.onHideCustomNotification} showModal={showCustomModel} id={challenge.id} type='challenge'/>}
              {<AddUserPopup onClose={this.onHideAddUserPopup} showModal={showAddUserPopup} challengeId={challenge.id} type={popupType} challengeType={challengeType} companyInfo={companyInfo}/>}
            </LayoutNew>
          </Main>
        }
      </React.Fragment>
    )
  }
}

ChallengeDetails.propTypes = {
  location: PropTypes.object.isRequired,
  challenge: PropTypes.object,
  getChallengeDetails: PropTypes.func.isRequired,
  addCommentOnChallenge: PropTypes.func.isRequired,
  getCommentsOnChallenge: PropTypes.func.isRequired,
  comments: PropTypes.array,
  networkError: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  fetchChallengeCompetitors: PropTypes.func.isRequired,
  postReplyOnComment: PropTypes.func.isRequired,
  replySuccess: PropTypes.string,
  fetchUserProfileImage: PropTypes.func.isRequired,
  profileImage: PropTypes.string,
  fetchUserId: PropTypes.func.isRequired,
  userId: PropTypes.number,
  fetchTeamChallenge: PropTypes.func.isRequired,
  history: PropTypes.object,
  role: PropTypes.string,
  updateDailyTask: PropTypes.func,
  weekDashboard: PropTypes.number,
  changeWeekDashboard: PropTypes.func,
  match: PropTypes.object.isRequired,
  challengeAttendees: PropTypes.array,
  getUserListOfChallenges: PropTypes.func,
  getUserLastSync: PropTypes.func,
  syncTime: PropTypes.string,
  getUserOverviewDetails: PropTypes.func,
  getChallengeCsvData: PropTypes.func,
  emptyChallengeDetails: PropTypes.func,
  toggleDummyChallenges: PropTypes.func,
  userPermissions: PropTypes.array,
  inviteAmigoStatus: PropTypes.bool,
  setChallengeInviteStatus: PropTypes.func,
  user: PropTypes.object,
  joinOrLeaveChallenge: PropTypes.func,
  teamChallenge:PropTypes.object,
  deleteChallengeById: PropTypes.func,
  getInviteAmigosList: PropTypes.func,
  challengeCSVStatus: PropTypes.object,
  challengeCsvData: PropTypes.array,
  UpdateUserLiveChallengeStatus: PropTypes.func,
  t: PropTypes.func,
  isAdminChallenge: PropTypes.bool,
  brandingColor:PropTypes.string,
  userChallengeDetails: PropTypes.object,
  companyInfo: PropTypes.object,
  allRoles:PropTypes.array
};

const mapStateToProps = (state) => ({
  challenge: state.challenges.challengeDetails,
  teamChallenge:state.challenges.teamChallengeDetails,
  comments: state.challenges.comments,
  isLoading: state.challenges.isLoading,
  networkError: state.challenges.networkError,
  replySuccess: state.challenges.replySuccess,
  profileImage: state.profileData.profileImage,
  userId: state.profileData.userId,
  role: state.auth.role,
  weekDashboard: state.challenges.weekDashboard,
  challengeAttendees: state.challenges.challengeAttendees,
  syncTime: state.challenges.syncTime,
  userPermissions: state.profileData.userPermissions,
  inviteAmigoStatus: state.challenges.inviteAmigoStatus,
  user: state.profileData.user,
  challengeCSVStatus: state.challenges.challengeCSVStatus,
  challengeCsvData: state.challenges.challengeCsvData,
  brandingColor:state.wellnessDashboard.brandingColor,
  userChallengeDetails: state.challenges.userChallengeDetails,
  allRoles: state.profileData.allRoles,
});

const mapDispatchToProps = (dispatch) => ({
  getChallengeDetails: (id, companyId) => dispatch(getChallengeDetails(id,companyId)),
  addCommentOnChallenge: (commentData) => dispatch(addCommentOnChallenge(commentData)),
  getCommentsOnChallenge: (id) => dispatch(getCommentsOnChallenge(id)),
  fetchChallengeCompetitors: (challengeId, challengeType, pageLimit, pageNumber, selectedOption, cb) => dispatch(getChallengeCompetitors(challengeId, challengeType, pageLimit, pageNumber, selectedOption, cb)),
  getUserOverviewDetails: (challengeId, challengeType, userId,companyId) => dispatch(getUserOverviewDetails(challengeId, challengeType, userId, companyId)),
  postReplyOnComment: (commentId, reply, challengeId) => dispatch(addCommentReplyOnChallenge(commentId, reply, challengeId)),
  fetchUserProfileImage: () => dispatch(getUserProfileImage()),
  fetchUserId: () => dispatch(getUserId()),
  fetchTeamChallenge: (challengeId, challengeType) => dispatch(getTeamChallenge(challengeId, challengeType)),
  updateDailyTask: (obj) => dispatch(updateDailyTask(obj)),
  changeWeekDashboard: (num) => dispatch(changeWeekDashboard(num)),
  getUserListOfChallenges: (challengeId) => dispatch(getUserListOfChallenges(challengeId)),
  getUserLastSync: () => dispatch(getUserLastSync()),
  getChallengeCsvData: (challengeId, challengeType, selectedOption, companyId) => dispatch(getChallengeCsvData(challengeId, challengeType, selectedOption, companyId)),
  emptyChallengeDetails: () => dispatch(emptyChallengeDetails()),
  toggleDummyChallenges: (bool) => dispatch(toggleDummyChallenges(bool)),
  setChallengeInviteStatus: (bool, challengeId) => dispatch(setChallengeInviteStatus(bool, challengeId)),
  joinOrLeaveChallenge: (data) => dispatch(joinOrLeaveChallenge(data)),
  deleteChallengeById: (id) => dispatch(deleteChallengeById(id)),
  getInviteAmigosList: (userID, challengeId) => dispatch(getInviteAmigosList(userID, challengeId)),
  UpdateUserLiveChallengeStatus: () => dispatch(UpdateUserLiveChallengeStatus()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChallengeDetails)));
